import React from 'react';
import { Button, Card, Typography, Space } from 'antd';
import { WindowsOutlined } from '@ant-design/icons';
import useAuth from '../hooks/useAuth';

const { Title, Text } = Typography;

const Login = () => {
  const { login } = useAuth();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      }}
    >
      <Card
        style={{
          width: 400,
          textAlign: 'center',
          borderRadius: 12,
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        }}
        bordered={false}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: '#E8192C',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                fontSize: 32,
                color: '#fff',
                fontWeight: 'bold',
              }}
            >
              GF
            </div>
            <Title level={2} style={{ margin: 0, color: '#1a1a2e' }}>
              GRUPO FAZA
            </Title>
            <Text type="secondary">Hub Unificado de Operaciones</Text>
          </div>

          <Button
            type="primary"
            size="large"
            icon={<WindowsOutlined />}
            onClick={login}
            style={{
              width: '100%',
              height: 48,
              borderRadius: 8,
              background: '#0078d4',
              borderColor: '#0078d4',
              fontSize: 16,
            }}
          >
            Iniciar sesión con Microsoft
          </Button>

          <Text type="secondary" style={{ fontSize: 12 }}>
            Usa tu cuenta de Office 365 de Grupo FAZA
          </Text>
        </Space>
      </Card>
    </div>
  );
};

export default Login;
